import { useTranslation } from 'react-i18next'

// eslint-disable-next-line import/prefer-default-export
export const useI18nLanguage = () => useTranslation().i18n.language
